/* eslint-disable jsx-a11y/anchor-is-valid */
import { useLocation, useNavigate } from "react-router-dom";

import { useContext, useEffect, useState } from "react";
import { InvoiceFormViewInterface } from "../../Interface/InvoiceForm";
import {
  APIResponseInterface,
  ToastInterface,
} from "../../Interface/ManageContractor";
import {
  fetchInvoiceService,
  postAcceptOrRejectInvoiceServices,
} from "../../Service/ManageInvoices/ManageInvoicesService";
import Loader from "../Loader";
import {  ppsContext } from "../../Configs/Constant";
import { AcceptOrRejectInvoicePayloadInterface } from "../../Interface/ManageInvoice";
import { contextValueInterface } from "../../Interface/HeaderDetails";
import Toast from "../Toast";
import moment from "moment";
import DatePicker from "react-multi-date-picker";
import { UploadToS3 } from "../../Service/ServiceRequest/ManageContractor/SignUp";
// import Toast from "../Toast/Toaster";

const InvoiceForm = () => {
  const initialToastDetails: ToastInterface = {
    isToast: false,
    toastDescription: "",
    toastMessage: "",
    toastType: "",
  };

  const initialAcceptOrRejectPayload: AcceptOrRejectInvoicePayloadInterface = {
    action: "",
    invoice_uuid: "",
    rejection_details: "",
  };

  const [invoiceData, setInvoiceData] = useState<InvoiceFormViewInterface>(
    {} as InvoiceFormViewInterface
  );

  // const [isLoading, setIsLoading] = useState<boolean>(false);
  const [isLoader, setIsLoader] = useState<boolean>(false);

  const [acceptOrRejectInvoicePayload, setAcceptOrRejectInvoicePayload] =
    useState<AcceptOrRejectInvoicePayloadInterface>(
      initialAcceptOrRejectPayload
    );
  const [rejectPopup, setRejectPopup] = useState<boolean>(false);
  const [showConfirmPopUp, setShowConfirmPopUp] = useState<boolean>(false);
  const [callFetchInvoice, setCallFetchInvoice] = useState<string>("");

  const contextValue: contextValueInterface = useContext(ppsContext);
  const [toastDetails, setToastDetails] =
    useState<ToastInterface>(initialToastDetails);

  const navigate = useNavigate();
  const locate = useLocation();

  useEffect(() => {
    if (locate?.state?.invoiceUUID) {
      fetchInvoice(locate?.state?.invoiceUUID);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (callFetchInvoice === "call") {
      fetchInvoice(locate?.state?.invoiceUUID);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [callFetchInvoice]);

  const fetchInvoice = async (invoiceUUID: string) => {
    try {
      setIsLoader(true);
      //PS_11 to PS_15
      const response: APIResponseInterface = await fetchInvoiceService(
        invoiceUUID
      );
      if (response?.status === "Success" && response?.code === 200) {
        const responseData: InvoiceFormViewInterface = response?.data;
        console.log(responseData);
        let invoiceData = responseData
        let getInvoiceFilePaylaod = {
          function: "PRESIGNED",
          url: invoiceData.invoice_doc_url
        }
        const retrieveFileResponse = await UploadToS3(getInvoiceFilePaylaod)
        if (retrieveFileResponse.code === 200) {
        invoiceData.invoice_doc_url = retrieveFileResponse.data.signed_url
        }
        setInvoiceData(invoiceData)
      }
      setCallFetchInvoice("");
    } catch (error) {
      // PS_22
      console.error("Error fetching form invoice dynamic data", error);
    } finally {
      setIsLoader(false);
    }
  };

  const postAcceptOrRejectInvoice = async (
    payload: AcceptOrRejectInvoicePayloadInterface
  ) => {
    setIsLoader(true);
    try {
      const response = await postAcceptOrRejectInvoiceServices(payload);
      setIsLoader(false);
      if (response?.status === "Success") {
        if (response?.message === "Invoice Status updated to Accepted") {
          setToastDetails((prevState) => ({
            ...prevState,
            isToast: true,
            toastDescription: "Invoice is accepted successfully",
            toastMessage: "Accepted",
            toastType: "Success",
          }));
        } else if (response?.message === "Invoice Status updated to Rejected") {
          setToastDetails((prevState) => ({
            ...prevState,
            isToast: true,
            toastDescription: "Invoice is rejected successfully",
            toastMessage: "Rejected",
            toastType: "Success",
          }));
        }
        setCallFetchInvoice("call");
      }
    } catch (error) {
      console.log(error);
    }
  };

  const handleAcceptOrRejectInvoice = (
    payload: AcceptOrRejectInvoicePayloadInterface
  ) => {
    postAcceptOrRejectInvoice(payload);
  };
 
  const handleConfirmPopUp = (message: string) => {
    if (message === "close" || message === "no") {
      setShowConfirmPopUp(false);
    } else {
      handleAcceptOrRejectInvoice(acceptOrRejectInvoicePayload);
      setShowConfirmPopUp(false);
    }
  };

  return isLoader ? (
    <Loader />
  ) : (
    <>
      <div className="container-fluid p-4 position-relative h-100 min-vh-100 invoice-form-field-page">
        {showConfirmPopUp && (
          <div
            className="modal fade show"
            id="exampleModal11"
            tabIndex={-1}
            aria-labelledby="exampleModalLabel"
            aria-hidden="true"
            style={{ display: "block", backgroundColor: "rgba(0,0,0,0.5)" }}
          >
            <div className="modal-dialog modal-dialog-centered">
              <div className="modal-content border-radius-10">
                <div className="modal-header border-0 px-4 pt-4 align-items-center">
                  <h5
                    className="modal-title font-bold font-18 color-black-v2"
                    id="exampleModalLabel"
                  >
                    {acceptOrRejectInvoicePayload.action?.toLowerCase() ===
                    "accepted"
                      ? "Accept"
                      : "Reject"}{" "}
                    Confirmation
                  </h5>
                  <button
                    type="button"
                    className="btn-close custom-btn-close"
                    onClick={() => {
                      handleConfirmPopUp("close");
                    }}
                    aria-label="Close"
                  ></button>
                </div>
                <div className="modal-body px-4 py-0">
                  <p className="font-medium font-16 mb-0 color-black cust-lh mb-3">
                    Are you sure you want to{" "}
                    {acceptOrRejectInvoicePayload.action?.toLowerCase() ===
                    "accepted"
                      ? "Accept"
                      : "Reject"}{" "}
                    this invoice?
                  </p>
                </div>
                <div className="modal-footer gap-2 border-0 px-4 pb-4 pt-2 justify-content-end">
                  <button
                    className="btn tertiary-btn px-4 color-white font-semibold font-14 primary-btn px-4"
                    onClick={() => {
                      handleConfirmPopUp("no");
                    }}
                  >
                    No
                  </button>
                  <button
                    className="btn primary-btn px-4 color-white font-semibold font-14 primary-btn px-4"
                    onClick={() => {
                      handleConfirmPopUp("yes");
                    }}
                  >
                    Yes
                  </button>
                </div>
              </div>
            </div>
          </div>
        )}
        {toastDetails?.isToast && (
          <Toast
            props={{
              isToast: toastDetails?.isToast,
              setToastDetails: setToastDetails,
              toastMessage: toastDetails?.toastMessage,
              toastType: toastDetails?.toastType,
              toastDescription: toastDetails?.toastDescription,
            }}
          />
        )}
        {rejectPopup && (
          <div
            className="modal fade show"
            style={{ display: "block" }}
            id="exampleModal3"
            tabIndex={-1}
            aria-labelledby="exampleModalLabel"
            aria-hidden="true"
            data-backdrop="static"
            data-keyboard="false"
          >
            <div className="modal-dialog modal-dialog-centered   ">
              <div className="modal-content border-radius-10">
                <div className="modal-header border-0 px-4 pt-4 align-items-start">
                  <h5
                    className="modal-title font-semibold font-18 color-black-v2"
                    id="exampleModalLabel"
                  >
                    Reject Reason
                  </h5>
                  <button
                    type="button"
                    className="btn-close custom-btn-close"
                    data-bs-dismiss="modal"
                    aria-label="Close"
                    onClick={() => {
                      setRejectPopup(false);
                      setAcceptOrRejectInvoicePayload(
                        initialAcceptOrRejectPayload
                      );
                    }}
                  />
                </div>
                <div className="modal-body px-4 py-2">
                  <div className="row align-items-center justify-content-center">
                    <div className="col-12 mb-4">
                      <div className="position-relative">
                        <label
                          htmlFor="textarea"
                          className="font-semibold font-14 color-black mb-2"
                        >
                          Rejection Details
                        </label>
                        <textarea
                          id="textarea"
                          className="form-control service-form-field w-100 custom-textarea font-14 font-regular bg-white"
                          placeholder="Enter a Rejection Details"
                          defaultValue={""}
                          onChange={(
                            event: React.ChangeEvent<HTMLTextAreaElement>
                          ) => {
                            setAcceptOrRejectInvoicePayload((prev) => ({
                              ...prev,
                              rejection_details: event.target.value,
                            }));
                          }}
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div className="modal-footer gap-2 border-0 px-4 pb-4 pt-2 justify-content-end">
                  <button
                    className="btn px-4 font-semibold font-14 shadow-none text-decoration-underline cust-text-underline secondary-btn"
                    onClick={() => {
                      setRejectPopup(false);
                      setAcceptOrRejectInvoicePayload(
                        initialAcceptOrRejectPayload
                      );
                    }}
                  >
                    Cancel
                  </button>
                  <button
                    className="btn primary-btn px-4 color-white font-semibold font-14 primary-btn px-4"
                    data-bs-target="#exampleModal3"
                    // disabled=""
                    onClick={() => {
                      setRejectPopup(false);
                      postAcceptOrRejectInvoice(acceptOrRejectInvoicePayload);
                    }}
                  >
                    Save
                  </button>
                </div>
              </div>
            </div>
          </div>
        )}
        {rejectPopup ? <div className="modal-backdrop fade show"></div> : <></>}
        <div className="px-md-5 px-md-3 mx-md-3">
          <div className="row d-flex align-items-center justify-content-center h-100  position-relative ">
            <div className="col-lg-9 col-sm-11 py-5 mb-4 mb-md-0">
              <div className="d-flex align-items-center gap-3 mt-4 px-md-5 pb-0">
                <a
                  className="back-btn d-flex align-items-center"
                  onClick={() => {
                    navigate(-1);
                  }}
                >
                  <img
                    className="icon-sty"
                    src="../images/black-back-arrow.svg"
                    alt="back-arrow"
                  />
                </a>
                <h2 className="color-black font-22 font-semibold mb-0">
                  {`View Invoice (${invoiceData.invoice_name})`}
                </h2>
              </div>
              <div className="position-relative">
                <div className="creation-container p-4 px-md-5 pb-4 pt-5 position-relative">
                  <div className="row">
                    <div className="col-md-6  mb-4">
                      <div className=" mb-1">
                        <label
                          htmlFor="job-request"
                          className="font-semibold font-15 primary-text-color mb-2"
                        >
                          Job Request
                        </label>
                        <select
                          name="example"
                          id="job-request"
                          disabled
                          className="w-100 d-block form-select invoice-form-fields cust-form-arrow   py-2 color-black-v1 font-14 font-regular"
                        >
                          <option value="">
                            {/* Zoobes award Ceremony - 1290 */}
                            {invoiceData.service_request}
                          </option>
                        </select>
                      </div>
                    </div>
                    <div className="col-md-6  mb-4">
                      <div className=" mb-1">
                        <label
                          htmlFor="business"
                          className="font-semibold font-15 primary-text-color mb-2 d-block"
                        >
                          Invoice PDF
                        </label>
                        <a
                          className="btn file-uploaded-btn font-medium font-14 px-4 py-2 mt-0-5 position-relative"
                          // onClick={() => {
                          //   invoiceDownloadS3File(invoiceData.invoice_doc_url);
                          // }}
                          target="blank"
                          href={invoiceData.invoice_doc_url}
                        >
                          {" "}
                          <span>{invoiceData.invoice_name}</span>
                        </a>
                      </div>
                    </div>
                    <div className="col-md-6  mb-4">
                      <div className=" mb-1">
                        <label
                          htmlFor="invoice-date"
                          className="font-semibold font-15 primary-text-color mb-2"
                        >
                          Invoice Date <span className="required-color">*</span>
                        </label> 
                        <input
                          type="text"
                          id="invoice-date"
                          disabled
                          // defaultValue={invoiceData?.invoice_date}
                          value={
                            invoiceData?.invoice_date
                              ? new Date(invoiceData?.invoice_date)
                                  .toISOString()
                                  .slice(0, 10)
                              : ""
                          }
                          className="form-control invoice-form-fields   py-2 color-black-v1 font-15 font-medium"
                        />
                      </div>
                    </div>
                    <div className="col-md-6  mb-4">
                      <div className=" mb-1">
                        <label
                          htmlFor="due-date"
                          className="font-semibold font-15 primary-text-color mb-2"
                        >
                          Due Date <span className="required-color">*</span>
                        </label>
                        <input
                          type="date"
                          id="due-date"
                          disabled
                          value={
                            invoiceData?.invoice_due_date
                              ? new Date(invoiceData?.invoice_due_date)
                                  .toISOString()
                                  .slice(0, 10)
                              : ""
                          }
                          className="form-control invoice-form-fields   py-2 color-black-v1 font-15 font-medium"
                        />
                      </div>
                    </div>
                    <div className="col-md-6  mb-4">
                      <div className=" mb-1">
                        <label
                          htmlFor="invoice"
                          className="font-semibold font-15 primary-text-color mb-2"
                        >
                          Invoice No #
                        </label>
                        <input
                          type="text"
                          id="invoice"
                          disabled
                          value={invoiceData?.invoice_no}
                          className="form-control invoice-form-fields   py-2 color-black-v1 font-15 font-medium"
                          placeholder="Enter Invoice #"
                        />
                      </div>
                    </div>
                    <div className="col-md-6  mb-4">
                      <div className=" mb-1">
                        <label
                          htmlFor="Status"
                          className="font-semibold font-15 primary-text-color mb-2"
                        >
                          Invoice Status
                        </label>
                        <select
                          name="invoice_status_uuid"
                          id="Status"
                          disabled
                          value={invoiceData.invoice_status_name}
                          className="w-100 d-block form-select invoice-form-fields cust-form-arrow   py-2 color-black-v1 font-14 font-regular"
                        >
                          <option value="option1">
                              {invoiceData?.invoice_status_name === "Admin Rejected" &&
                                (contextValue.userDetails.role.toLowerCase() ===
                                "admin"
                                  ? "Rejected"
                                  : invoiceData?.invoice_status_name)}
                              {invoiceData?.invoice_status_name === "Admin Approved"
                                ? "Approved"
                                : ""}
                              {invoiceData?.invoice_status_name === "RM Approved" &&
                                "RM Approved"}
                              {invoiceData?.invoice_status_name === "RM Rejected" &&
                                (contextValue.userDetails.role.toLowerCase() ===
                                "regional manager"
                                  ? "Rejected"
                                  : "")}
                              {/* {data.invoice_status_name} */}
                              {invoiceData?.invoice_status_name === "Paid" && "Paid"}
                              {invoiceData?.invoice_status_name === "Open" && "Open"}
                          </option>
                        </select>
                      </div>
                    </div>
                    {invoiceData?.invoice_lines?.map((line) => (
                      <div className="row mx-0 mb-4 conformation-form">
                        <div className="col-md-6  mb-4">
                          <div className=" mb-1">
                            <label
                              htmlFor="category"
                              className="font-semibold font-15 primary-text-color mb-2"
                            >
                              Category
                            </label>
                            <select
                              name="example"
                              id="category"
                              disabled
                              className="w-100 d-block form-select invoice-form-fields cust-form-arrow   py-2 color-black-v1 font-14 font-regular"
                            >
                              <option value="option1">
                                {line?.quickbooks_category_name}
                              </option>
                            </select>
                          </div>
                        </div>
                        <div className="col-md-6  mb-4">
                          <div className=" mb-1">
                            <label
                              htmlFor="start-and-end-date"
                              className="font-semibold font-15 primary-text-color mb-2"
                            >
                              Start and End Date
                            </label>
                            {/* <input
                              type="text"
                              id="start-and-end-date"
                              disabled
                              value={line.start_date + "  -  " + line.end_date}
                              className="form-control invoice-form-fields   py-2 color-black-v1 font-15 font-medium"
                            /> */}
                            <DatePicker
                              id="Date1"
                              key={`calendar`}
                              range
                              className="w-100"
                              numberOfMonths={2}
                              format="MM/DD/YYYY"
                              disabled
                              style={{
                                display:'block',
                                height:'max-content'
                              }}
                              render={(
                                value: string,
                                openCalendar: () => void
                              ) => {
                                return (
                                  <input
                                    style={{
                                      width: "100%",
                                      fontFamily: "Montserrat-Regular", // Default font family
                                      fontSize: "14px", // Default font size
                                      cursor: "pointer",
                                      color: "Black",
                                      padding: "10px", // Add padding if needed
                                      border: "1px solid #ccc", // Add a border if needed
                                      borderRadius: "5px", // Add border-radius if needed
                                    }}
                                    value={
                                      line.start_date &&
                                      line.end_date
                                        ? `${moment(
                                            line.start_date
                                          ).format("MM/DD/YYYY")} - ${moment(
                                            line.end_date
                                          ).format("MM/DD/YYYY")}`
                                        : ""
                                    }
                                    readOnly
                                    className="fcalendar-month-name service-form-field color-black-v2 font-14 font-regular w-100"
                                    placeholder="Select date"
                                  />
                                );
                              }}
                              mapDays={({ date }) => {
                                const props: any = {};
                                // eslint-disable-next-line @typescript-eslint/no-unused-vars
                                const isToday =
                                  date.format("YYYY-MM-DD") ===
                                  moment().format("YYYY-MM-DD");
                                const isSelectedStart =
                                 line.start_date &&
                                  date.format("YYYY-MM-DD") ===
                                    moment(
                                      line
                                        .start_date
                                    ).format("YYYY-MM-DD");
                                const isSelectedEnd =
                                  line.end_date &&
                                  date.format("YYYY-MM-DD") ===
                                    moment(
                                      line
                                        .end_date
                                    ).format("YYYY-MM-DD");
                                // eslint-disable-next-line @typescript-eslint/no-unused-vars
                                const isInRange =
                                  isSelectedStart ||
                                  isSelectedEnd ||
                                  (line
                                    .start_date &&
                                    line
                                      .end_date &&
                                    date.toDate() >=
                                      moment(
                                        line
                                          .start_date
                                      ).toDate() &&
                                    date.toDate() <=
                                      moment(
                                        line
                                          .end_date
                                      ).toDate());
                                return props;
                              }}
                            />
                          </div>
                        </div>
                        <div className="col-md-4">
                          <div className="position-relative">
                            <label
                              htmlFor="InvoiceAmount"
                              className="font-semibold font-14 color-black mb-2"
                            >
                              Hours Worked
                            </label>
                            <div className="d-flex align-items-center invoice-form-field p-0">
                              <button className="border-0 h-100 clock-field-btn"></button>
                              <input
                                type="number"
                                id="InvoiceAmount"
                                disabled
                                className="form-control bg-white color-black-v2 font-14 font-medium invoice-form-field border-0 rounded-0"
                                value={line?.hours_worked}
                              />
                            </div>
                          </div>
                        </div>
                        <div className="col-md-4">
                          <div className="position-relative">
                            <label
                              htmlFor="InvoiceAmount"
                              className="font-semibold font-14 primary-text-color mb-2"
                            >
                              Invoice Amount
                            </label>
                            <div className="d-flex align-items-center invoice-form-field p-0">
                              <button className="border-0 h-100 amount-btn"></button>
                              <input
                                type="number"
                                id="InvoiceAmount"
                                disabled
                                className="form-control bg-white color-black-v2 font-14 font-medium invoice-form-field border-0 rounded-0"
                                value={line?.invoice_amount}
                              />
                            </div>
                          </div>
                        </div>
                        <div className="col-md-4">
                          <div className=" mb-1">
                            <label
                              htmlFor="class"
                              className="font-semibold font-15 primary-text-color mb-2"
                            >
                              Class
                            </label>
                            <select
                              name="example"
                              id="class"
                              disabled
                              value={line?.quickbooks_class_name}
                              className="w-100 d-block form-select invoice-form-fields bg-white     cust-form-arrow   py-2 color-black-v1 font-14 font-regular"
                            >
                              <option value="option1">
                                {line?.quickbooks_class_name}
                              </option>
                            </select>
                          </div>
                        </div>
                      </div>
                    ))}
                    <div className="col-md-12 d-flex justify-content-between mt-5 px-0">
                      <button
                        className="btn font-semibold p-0 font-14 shadow-none text-decoration-underline cust-text-underline secondary-btn"
                        onClick={() => {
                          navigate(-1);
                        }}
                      >
                        Cancel
                      </button>
                      <div className="d-flex align-items-center gap-3">
                        <button
                          className="btn px-5 py-2 font-semibold font-14 shadow-none reject-btn"
                          // data-bs-toggle="modal"
                          // data-bs-target="#exampleModal2"

                          disabled={
                            contextValue.userDetails.role === "Admin"
                              ? invoiceData.invoice_status_name?.toLowerCase() ===
                                "rm approved"
                                ? // data.invoice_status_name.toLowerCase() === "Accepted" ||
                                  // data.invoice_status_name.toLowerCase() === "Rejected"
                                  false
                                : true
                              : invoiceData.invoice_status_name?.toLowerCase() ===
                                "open"
                              ? // data.invoice_status_name.toLowerCase() === "Accepted" ||
                                // data.invoice_status_name.toLowerCase() === "Rejected"
                                false
                              : true
                          }
                          onClick={() => {
                            setAcceptOrRejectInvoicePayload((prevState) => ({
                              ...prevState,
                              action: "Rejected",
                              invoice_uuid: invoiceData.invoice_uuid,
                            }));
                            // setShowConfirmPopUp(true);
                            setRejectPopup(true);
                          }}
                        >
                          Reject
                        </button>
                        <button
                          className="btn px-5 py-2 font-semibold font-14 shadow-none accept-btn"
                          // data-bs-toggle="modal"
                          // data-bs-target="#exampleModal2"
                          disabled={
                            contextValue.userDetails.role === "Admin"
                              ? invoiceData.invoice_status_name?.toLowerCase() ===
                                "rm approved"
                                ? // data.invoice_status_name.toLowerCase() === "Accepted" ||
                                  // data.invoice_status_name.toLowerCase() === "Rejected"
                                  false
                                : true
                              : invoiceData.invoice_status_name?.toLowerCase() ===
                                "open"
                              ? // data.invoice_status_name.toLowerCase() === "Accepted" ||
                                // data.invoice_status_name.toLowerCase() === "Rejected"
                                false
                              : true
                          }
                          onClick={() => {
                            setAcceptOrRejectInvoicePayload((prevState) => ({
                              ...prevState,
                              action: "Accepted",
                              invoice_uuid: invoiceData.invoice_uuid,
                            }));
                            setShowConfirmPopUp(true);
                          }}
                        >
                          Accept
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* {toastDetails?.isToast && (
        <Toast
          props={{
            isToast: toastDetails?.isToast,
            setToastDetails: setToastDetails,
            toastMessage: toastDetails?.toastMessage,
            toastType: toastDetails?.toastType,
            toastDescription: toastDetails?.toastDescription,
          }}
        />
      )} */}
    </>
  );
};

export default InvoiceForm;
